<template>
    <Header />
    <section class="orbital vv-main" data-barba="container" data-barba-namespace="orbital">
        <div id="krpano-tag" style="width:100vw;height:100vh;" ref="krpano"></div>
    </section>
</template>

<script>
    import Header from "../components/Header"
    import Axios from "axios";

    export default {
        beforeMount() {
            Axios.get(process.env.MIX_APP_URL + '/domain?include=settings,files,videos,videos.formats,videos.thumb').then((response) => {
                this.domain = response.data.data;

                embedpano({
                    xml: `${window.location.origin}/storage/cyclorama/${this.domain.name.toLowerCase()}/tour.xml`,
                    target: 'krpano-tag',
                    html5: 'only',
                    passQueryParameters: true,
                    onready: this.handleReady,
                    id: "KRPANO-VIEWER",
                    consolelog: false,
                    basepath: `${window.location.origin}/storage/cyclorama/${this.domain.name.toLowerCase()}/`
                });

                Axios.get(process.env.MIX_APP_URL + '/domain?include=settings,files,videos,videos.formats,videos.thumb,tours,tours.thumb').then((response) => {
                    this.domain = response.data.data;

                    Axios.get(`${window.location.origin}/storage/cyclorama/${this.domain.name.toLowerCase()}/tour.xml`).then( (file) => {
                        this.isCycloramaAvailable = file.headers['content-type'] === 'application/xml; charset=utf-8';
                    })

                    Axios.get(`${window.location.origin}/storage/vtour/${this.domain.name.toLowerCase()}/1/tour.xml`).then( (file) => {
                        this.isVirtualTourAvailable = file.headers['content-type'] === 'application/xml; charset=utf-8';
                    })
                })
            })
        },
        data() {
            return {
                isVirtualTourAvailable: false,
                isCycloramaAvailable: false,
                domain: null
            }
        },
        computed: {
            upperLeftLogo() {
                if (this.domain && this.domain.settings.data.find(setting => setting.name === 'upper-left-logo') && this.domain.settings.data.find(setting => setting.name === 'upper-left-logo').image) {
                    return this.domain.settings.data.find(setting => setting.name === 'upper-left-logo').image.url
                }

                return null
            },
            secondaryLogo() {
                if (this.domain && this.domain.settings.data.find(setting => setting.name === 'secondary-logo') && this.domain.settings.data.find(setting => setting.name === 'secondary-logo').image) {
                    return this.domain.settings.data.find(setting => setting.name === 'secondary-logo').image.url
                }

                return null
            },
            whiteLogo() {
                if (this.domain && this.domain.settings.data.find(setting => setting.name === 'white-logo') && this.domain.settings.data.find(setting => setting.name === 'white-logo').image) {
                    return this.domain.settings.data.find(setting => setting.name === 'white-logo').image.url
                }

                return null
            },
            blackLogo() {
                if (this.domain && this.domain.settings.data.find(setting => setting.name === 'black-logo') && this.domain.settings.data.find(setting => setting.name === 'black-logo').image) {
                    return this.domain.settings.data.find(setting => setting.name === 'black-logo').image.url
                }

                return null
            },
            splashImage() {
                if (this.domain && this.domain.settings.data.find(setting => setting.name === 'splash-image') && this.domain.settings.data.find(setting => setting.name === 'splash-image').image) {
                    return this.domain.settings.data.find(setting => setting.name === 'splash-image').image.url
                }

                return '/img/landing-img.png'
            },
            withFilter() {
                if (this.domain && this.domain.settings.data.find(setting => setting.name === 'with-filter')) {
                    return !!Number(this.domain.settings.data.find(setting => setting.name === 'with-filter').value)
                }

                return false
            },
            withMenu() {
                if (this.domain && this.domain.settings.data.find(setting => setting.name === 'with-menu')) {
                    return !!Number(this.domain.settings.data.find(setting => setting.name === 'with-menu').value)
                }

                return false
            },
            withModal() {
                if (this.domain && this.domain.settings.data.find(setting => setting.name === 'with-modal')) {
                    return !!Number(this.domain.settings.data.find(setting => setting.name === 'with-modal').value)
                }

                return false
            }
        },
        methods: {
            handleReady() {
            }
        },
        components: {
            Header
        }
    }
</script>
